import type { FC, ReactNode } from "react";
import { Navigate } from "react-router";
import { appPaths } from "../../app/appPaths.js";
import {
  useSettingsSectionsPolicy,
  type SettingsSectionKey,
} from "./settingsSectionsPolicy.js";

/**
 * Render-time access check for a settings section, driven by the shared
 * sections policy. The settings routes are static (the data router is built
 * before boot data exists), so the conditional visibility that used to
 * decide which descendant routes were registered lives here instead; a
 * denied section redirects to the profile, which everyone can access.
 */
export const SettingsSectionGuard: FC<{
  section: SettingsSectionKey;
  children: ReactNode;
}> = ({ section, children }) => {
  const policy = useSettingsSectionsPolicy();

  if (!policy.sections[section].canAccess) {
    return <Navigate to={appPaths.settingsProfile.build()} replace />;
  }

  return <>{children}</>;
};
